import { render, staticRenderFns } from "./FilmScore.vue?vue&type=template&id=01b21694&scoped=true&"
import script from "./FilmScore.vue?vue&type=script&lang=js&"
export * from "./FilmScore.vue?vue&type=script&lang=js&"
import style0 from "./FilmScore.vue?vue&type=style&index=0&id=01b21694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b21694",
  null
  
)

export default component.exports